export default __webpack_public_path__ + "static/1995-12-01_perceptual_JAES.pdf";